"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalOutreachService = void 0;
class InternalOutreachService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Get emails by params
     * @param outreachFlowId
     * @param emailPolicyId
     * @returns GetEmailsResponse
     * @throws ApiError
     */
    getDeploymentEmails(outreachFlowId, emailPolicyId) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/internal/outreach/flows/{outreachFlowId}/policies/{emailPolicyId}/emails',
            path: {
                'outreachFlowId': outreachFlowId,
                'emailPolicyId': emailPolicyId,
            },
        });
    }
    /**
     * Get all outreach flows
     * @returns GetOutreachFlowsResponse
     * @throws ApiError
     */
    getInternalOutreachFlows() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/internal/outreach/flows',
        });
    }
    /**
     * Get a all flow email policy
     * @param outreachFlowId
     * @returns GetAllOutreachFlowEmailPoliciesResponse
     * @throws ApiError
     */
    getInternalAllOutreachEmailPolicies(outreachFlowId) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/internal/outreach/flows/{outreachFlowId}/policies',
            path: {
                'outreachFlowId': outreachFlowId,
            },
        });
    }
    /**
     * update outreach flow last used
     * @param outreachFlowId
     * @param requestBody UpdateOutreachFlowPayload
     * @returns any Successful response
     * @throws ApiError
     */
    updateOutreachFlowLastUsed(outreachFlowId, requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/internal/outreach/flows/{outreachFlowId}/last-used',
            path: {
                'outreachFlowId': outreachFlowId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * update outreach email policy last used
     * @param outreachFlowId
     * @param emailPolicyId
     * @param requestBody UpdateOutreachEmailPolicyPayload
     * @returns any Successful response
     * @throws ApiError
     */
    updateOutreachEmailPolicyLastUsed(outreachFlowId, emailPolicyId, requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/internal/outreach/flows/{outreachFlowId}/policy/{emailPolicyId}/last-used',
            path: {
                'outreachFlowId': outreachFlowId,
                'emailPolicyId': emailPolicyId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
exports.InternalOutreachService = InternalOutreachService;
